<template lang="pug">
.custom_dialog
  .dialog_container
    .dialog_close_btn(@click="closeClick")
      img(src="@/assets/img/icons/close.svg")
    h2.dialog_title 請再次確認以下金額
    .dialog_content
      h5.mt-4 購買課程
      p.course_group {{ courseData.product_group_name }}
      p {{ courseData.name }} (NT. {{ courseData.price }})

      h5.mt-5(v-if="extraData.length > 0") 加購商品
      .product_wrapper.mt-3(v-if="extraData.length > 0")
        .item_detail.d-flex.justify-content-between.align-items-center(
          v-for="selectedProduct in extraData"
        )
          img(v-if="selectedProduct.photo", :src="selectedProduct.photo.image")
          p {{ selectedProduct.name }}
          p.price $
            span(v-if="selectedProduct.price != '0'") {{ selectedProduct.price }}
            span(v-else) 依距離收費
      hr.mt-5
      .total.d-flex.justify-content-between
        h5 總計
        p $
          span {{ total }} {{ zeroMessage }}

      .btns.d-flex.mt-4
        .round_btn.cancel_btn(@click="closeClick") 再次查看
        .round_btn.confirm_btn(@click="confirm") 確認送出
</template>

<script>
import { getProduct } from "@/api/enroll";

export default {
  name: "EnrollConfirmDialog",
  props: {
    selectedProducts: Array,
    productSelect: Number,
    selectExtraProducts: Array,
  },
  data() {
    return {
      courseData: {},
      extraData: [],
      total: 0,
      zeroMessage: "",
    };
  },
  created() {
    this.getCourse();
  },
  methods: {
    closeClick() {
      this.$emit("closeEnrollConfirmDialog");
    },
    confirm() {
      this.$emit("toComplete");
    },
    getCourse() {
      getProduct(this.productSelect).then((response) => {
        this.courseData = response.data;
        this.total = this.total + this.courseData.price;
        this.getExtra();
      });
    },
    getExtra() {
      this.extraData = [];
      if (this.selectExtraProducts.length > 0) {
        for (let index in this.selectExtraProducts) {
          let temp = this.selectExtraProducts[index];
          getProduct(temp).then((response) => {
            this.total = this.total + response.data.price;
            this.extraData.push(response.data);
            if (response.data.price == 0) {
              this.zeroMessage = "+ 依距離收費";
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/dialog/dialog";

.custom_dialog {
  .dialog_container {
    width: 860px;
    max-width: 80%;
    max-height: 100%;
  }

  .dialog_content {
    overflow: scroll;
    height: auto;
    max-height: calc(100vh - 100px);

    .course_group {
      font-weight: 500;
    }

    p {
      text-align: center;
    }

    h5 {
      color: $c-main;
      text-align: left;
    }

    p.price {
      color: $c-main;
    }

    .product_wrapper {
      height: auto;
      width: 100%;
      border: 1px solid #b9bdc7;
    }

    .item_detail {
      padding: 10px 30px;
      height: auto;
      min-height: 72px;
      border-bottom: 1px solid #b9bdc7;

      &:last-child {
        border-bottom: none;
      }
      img {
        width: 60px;
        height: 60px;
      }
    }

    .total {
      p {
        font-size: 24px;
      }
    }
  }
}

.round_btn {
  @include rect_radius(100%, 44px, #35376a, 22px, transparent, 0);
  margin-left: 10px;
  margin-right: 10px;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  line-height: 44px;
  font-size: 18px;
  color: white;

  &:hover {
    background-color: $c-main-icon;
  }
}

.cancel_btn {
  background-color: #6d7278;

  &:hover {
    background-color: #9ea2a7;
  }
}

// RWD > extra small
@media (max-width: 575px) {
  .custom_dialog {
    .dialog_container {
      width: 100%;
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }

    .dialog_btn {
      width: 100%;
    }
  }
}
</style>
